import { differenceInDays } from 'date-fns'
import { useCallback, useEffect, useRef, useState } from 'react'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import { getProfileHeader, postOpenid } from '../../api/auth'
import { getUserNotiSettingHeader, postKakaoCode, postLogin, postSendCode, postVerifyCode } from '../../api/login'
import { getOrderListHeader } from '../../api/orderHistory'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { useMyContext } from '../../components/provider/MyProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/Member.css'
import { sendSetAppsflyerEvent } from '../../js/postMessage'
import { delPrevScroll, handleAccessToken } from '../../js/script'

export default function KakaoAuth({
  setText,
  setPhoneNumber,
  phoneNumber,
  messageId,
  setMessageId,
  code,
  setCode,
  os,
  setVerificationCheckCode,
  closeModal,
  email,
  setEmail,
}: any) {
  const [phonecheck, setPhoneCheck] = useState<boolean>(true)
  const [emailCheck, setEmailCheck] = useState<boolean>(false)
  const [codeCheck, setCodeCheck] = useState<boolean>(false)
  const [codeFocus, setCodeFocus] = useState<boolean>(false)
  const [time, setTime] = useState<number>(3 * 60) // 3분을 초로 변환 (3분 * 60초)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [authCheck, setAuthCheck] = useState<boolean>(false)
  const [emailValidate, setEmailValidate] = useState<boolean>(false)
  const [phoneSubmit, setPhoneSubmit] = useState<boolean>(true)
  const [kakaoMessage, setKakaoMessage] = useState<string>('')
  const [seconds, setSeconds] = useState<number>(180)
  const timerRef = useRef<HTMLDivElement>(null) // Add this line
  const { isAppView } = useAppContext()
  const { setToastMessage, setIsToast } = useMyContext()
  const { setHasAccessToken } = useCommonContext()
  const navigate = useNavigate()

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  const decrementSeconds = useCallback(() => {
    setSeconds((prevSeconds) => prevSeconds - 1)
  }, [])

  useEffect(() => {
    if (phoneSubmit && seconds !== 0) {
      //@ts-ignore
      timerRef.current = setInterval(decrementSeconds, 1000) // Change this line
      //@ts-ignore
      return () => clearInterval(timerRef.current)
    }
  }, [decrementSeconds, phoneSubmit, seconds])

  useEffect(() => {
    if (seconds === 0) {
      //@ts-ignore
      clearInterval(timerRef.current) // Change this line
    }
  }, [seconds])

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null

    if (phoneSubmit && time > 0) {
      // phoneSubmit 조건 추가
      interval = setInterval(() => {
        setTime((prevTime) => prevTime - 1)
      }, 1000)
    } else if (time === 0) {
      if (interval) {
        clearInterval(interval)
      }
      setIsActive(false)
    }

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [phoneSubmit, time])
  const formatTime = (seconds: any) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  function validatePhoneNumber(number: any) {
    const phonePattern = /^(01[016789])-?\d{4}-?\d{4}$/

    if (phonePattern.test(number)) {
      setPhoneCheck(true)
      return true
    } else {
      setPhoneCheck(false)
      return false
    }
  }

  function daysBetweenDates(startDate: any) {
    const today = new Date() // 오늘 날짜
    const start = new Date(startDate) // 입력받은 날짜
    return differenceInDays(today, start)
  }

  const validateEmail = (email: string) => {
    // 수정된 정규식: {2,}를 {2,4}로 변경하여 2-4글자로 제한
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    return emailPattern.test(email)
  }

  useEffect(() => {
    setEmailValidate(validateEmail(email))
  }, [email])

  useEffect(() => {
    if (code.length === 4) {
      postVerifyCode(phoneNumber, kakaoMessage, code)
        .then((res) => {
          setVerificationCheckCode(res.data.verificationCheckCode)
          postLogin(phoneNumber, res.data.verificationCheckCode, os)
            .then((res) => {
              setAuthCheck(true)
              if (res.data.code === 'E0123') {
                setEmailCheck(true)
                setTimeout(() => {
                  ;(document.querySelector('.email_input') as HTMLInputElement)?.focus()
                }, 100)
              } else if (res.data.code === 'E0127') {
                alert('회원탈퇴 한지 7일이 지나지 않았습니다.')
              } else if (res.data.code === 'E0125') {
                alert('회원탈퇴 한지 180일이 지나지 않았습니다.')
              } else if (res.data.code === 'E0111') {
                navigate(`/sanctions`, {
                  state: { userData: res.data },
                })
                closeModal()
              } else {
                window.localStorage.setItem(`aboutRefreshToken`, JSON.stringify(res.data.refreshToken))
                window.localStorage.setItem(`aboutAccessToken`, JSON.stringify(res.data.accessToken))
                postOpenid(res.data.accessToken)
                  .then((response) => {
                    setIsToast(true)
                    setToastMessage('로그인이 완료 되었어요.')
                    const noti: any = getUserNotiSettingHeader(res.data.accessToken).then((res) => {
                      return res.data
                    })

                    window.localStorage.setItem(`accessToken`, JSON.stringify(response.data.accessToken))
                    getProfileHeader(response.data.accessToken).then((respon) => {
                      getOrderListHeader(response.data.accessToken).then((re) => {
                        let totalPrice = 0
                        re.data.items.forEach((item: any) => {
                          totalPrice += item.lastOrderAmt.payAmt
                        })
                        const gtmLogin: DataLayerArgs = {
                          dataLayer: {
                            event: 'login',
                            event_info: {
                              method: 'general',
                            }, // ecommerce 이벤트 중 상품보기 단계
                            user_info: {
                              login_status: 'Y',
                              user_id: res.data.user.id,
                              sign_up_date: respon.data.joinYmdt,
                              days_from_sign_up: daysBetweenDates(respon.data.joinYmdt),
                              days_from_last_visit: daysBetweenDates(respon.data.lastLoginYmdt),
                              total_purchases_count: re.data.totalCount,
                              total_purchases_revenue: totalPrice,
                              marketing_consent_status: noti.isMarketing ? 'Y' : 'N',
                              push_consent_status: respon.data.pushNotificationAgreed ? 'Y' : 'N',
                              sms_consent_status: respon.data.smsAgreed ? 'Y' : 'N',
                              ems_consent_status: respon.data.directMailAgreed ? 'Y' : 'N',
                              member_grade: respon.data.memberGradeName,
                              subscription_status: undefined,
                              subscription_period: undefined,
                              fish_post_count: undefined,
                              general_post_count: undefined,
                              comment_count: undefined,
                              post_like_count: undefined,
                            },
                          },
                        }
                        if (isAppView) {
                          sendSetAppsflyerEvent({
                            eventName: 'login',
                            eventType: {
                              method: 'general',
                              login_status: 'Y',
                              user_id: res.data.user.id,
                              sign_up_date: respon.data.joinYmdt,
                              days_from_sign_up: daysBetweenDates(respon.data.joinYmdt),
                              days_from_last_visit: daysBetweenDates(respon.data.lastLoginYmdt),
                              total_purchases_count: re.data.totalCount,
                              total_purchases_revenue: totalPrice,
                              marketing_consent_status: noti.isMarketing ? 'Y' : 'N',
                              push_consent_status: respon.data.pushNotificationAgreed ? 'Y' : 'N',
                              sms_consent_status: respon.data.smsAgreed ? 'Y' : 'N',
                              ems_consent_status: respon.data.directMailAgreed ? 'Y' : 'N',
                              member_grade: respon.data.memberGradeName,
                              subscription_status: undefined,
                              subscription_period: undefined,
                              fish_post_count: undefined,
                              general_post_count: undefined,
                              comment_count: undefined,
                              post_like_count: undefined,
                            },
                          })
                        } else {
                          TagManager.dataLayer(gtmLogin)
                        }
                      })
                    })

                    setTimeout(() => {
                      closeModal()

                      handleAccessToken()
                      delPrevScroll()
                      navigate('/')
                      setHasAccessToken(true)
                      // window.location.reload();
                    }, 3000)
                  })
                  .catch((err) => {
                    setAuthCheck(true)
                    window.localStorage.setItem(`aboutRefreshToken`, JSON.stringify([]))
                    window.localStorage.setItem(`aboutAccessToken`, JSON.stringify([]))
                  })
              }
            })
            .catch((err) => setAuthCheck(true))
        })
        .catch((err) => setAuthCheck(true))
    }
  }, [code])

  useEffect(() => {
    if (phoneNumber.length === 11) {
      postKakaoCode(phoneNumber)
        .then((res) => {
          console.log(res.data)
          setMessageId(res.data.message)
          setKakaoMessage(res.data.message)
          setCodeCheck(true)
        })
        .catch((err) => console.log(err))
    }
  }, [])

  return (
    <>
      <PageTitle className='small' style={{ padding: '0 20px 12px', fontSize: '22px', lineHeight: '26px' }}>
        <span style={{ color: '#0041FF' }}>카카오톡</span>으로 <br />
        인증번호를 발송 드렸어요.
      </PageTitle>
      <div className='member_wrap'>
        <div className='profile_wrap'>
          <div className='profile_info'>
            {emailCheck && (
              <div className='inp_box'>
                {!emailValidate && (
                  <p
                    style={{
                      height: '17px',
                      display: 'flex',
                      justifyContent: 'flex-end',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    <em style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                      <img src='../../images/ic-info.svg' alt='' style={{ width: '14px', height: '14px' }} />
                      올바른 이메일을 입력해주세요.
                    </em>
                  </p>
                )}
                <div
                  className={codeFocus ? 'certf_cont' : 'certf_cont'}
                  // style={{
                  //   borderColor: codeFocus
                  //     ? "rgba(255, 23, 23, 0.60)"
                  //     : colorObj.colGray3,
                  // }}
                >
                  <div className='phone_cont'>
                    <input
                      type='text'
                      placeholder='이메일'
                      onChange={(e) => {
                        setEmail(e.target.value)
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className='inp_box'>
              {!authCheck && (
                <p
                  style={{
                    height: '17px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    fontSize: '14px',
                    lineHeight: '16px',
                  }}
                >
                  <em style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <img src='../../images/ic-info.svg' alt='' style={{ width: '14px', height: '14px' }} />
                    인증번호를 확인해주세요
                  </em>
                </p>
              )}
              <div
                className={codeFocus ? 'certf_cont' : 'certf_cont'}
                // style={{
                //   borderColor: codeFocus
                //     ? "rgba(255, 23, 23, 0.60)"
                //     : colorObj.colGray3,
                // }}
              >
                <div className='phone_cont'>
                  <input
                    type='text'
                    className='auth_input'
                    inputMode='numeric'
                    placeholder='인증번호 4자리'
                    maxLength={4}
                    value={code}
                    onChange={(e) => {
                      setCode(e.target.value)
                    }}
                    onFocus={() => {
                      setCodeFocus(true)
                    }}
                    onBlur={() => {
                      setCodeFocus(false)
                    }}
                  />
                  {phoneSubmit && seconds !== 0 ? (
                    <em>{formatTime(time)}</em>
                  ) : (
                    <button
                      type='button'
                      className='certf_btn'
                      style={{ minWidth: '37px' }}
                      onClick={() => {
                        setIsActive(true)
                        postKakaoCode(phoneNumber)
                          .then((res) => {
                            setMessageId(res.data.messageId)

                            setSeconds(180)
                            setTime(3 * 60)
                          })
                          .catch((err) => console.log(err))
                      }}
                    >
                      재전송
                    </button>
                  )}
                </div>

                <a
                  href=''
                  onClick={(e) => {
                    e.preventDefault()
                    const open: Window | null = window.open('about:blank', '_blank')
                    if (open) {
                      open.location.href = 'https://app-bridge.aboutfishing.kr/faq/37'
                    }
                  }}
                  style={{
                    display: 'block',
                    marginTop: '12px',
                    fontSize: '15px',
                    lineHeight: '18px',
                    color: '#0041FF',
                    padding: '0 5px',
                  }}
                >
                  카카오톡으로도 문자가 오지 않아요.
                </a>
              </div>
            </div>

            <div className='inp_box'>
              {!phonecheck && (
                <p
                  style={{
                    height: '17px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    fontSize: '14px',
                    lineHeight: '16px',
                  }}
                >
                  <em style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <img src='../../images/ic-info.svg' alt='' style={{ width: '14px', height: '14px' }} />
                    휴대폰번호를 확인해주세요.
                  </em>
                </p>
              )}
              <div className='phone_cont '>
                <input
                  type='text'
                  placeholder='휴대폰번호'
                  pattern='[0-9]*'
                  inputMode='numeric'
                  value={phoneNumber} // controlled input으로 만들어 줍니다
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 11)
                    setPhoneNumber(value)
                    validatePhoneNumber(value)

                    if (validatePhoneNumber(value) && value.startsWith('010')) {
                      e.target.blur() // 현재 입력창 포커스 해제
                      setAuthCheck(false)
                      setCode('')
                      setSeconds(180)
                      setTime(3 * 60)
                      postKakaoCode(value)
                        .then((res) => {
                          setMessageId(res.data.messageId)
                          setKakaoMessage(res.data.message)

                          setCodeCheck(true)
                          // 다음 입력창으로 포커스 이동
                          setTimeout(() => {
                            ;(document.querySelector('.auth_input') as HTMLInputElement)?.focus()
                          }, 100)
                        })
                        .catch((err) => console.log(err))
                    }
                  }}
                  style={{ outline: 'none' }}
                  maxLength={11}
                />
              </div>
              <a
                href=''
                onClick={(e) => {
                  e.preventDefault()
                  setText('phonechange')
                }}
                style={{
                  display: 'block',
                  marginTop: '12px',
                  fontSize: '15px',
                  lineHeight: '18px',
                  color: '#0041FF',
                  padding: '0 5px',
                }}
              >
                이전에 가입했는데 휴대폰번호가 변경됐어요.
              </a>
            </div>
          </div>
        </div>
        <div className='bot_txt_box'>
          <button
            type='button'
            className='btn_save'
            style={{
              borderRadius: 0,
              background: validateEmail(email) && authCheck && phonecheck ? 'var(--colBlack)' : 'var(--colGray2)',
              color: validateEmail(email) && authCheck && phonecheck ? 'var(--colWhite)' : 'var(--colGray4)',
              fontSize: '16px',
              lineHeight: '20px',
              padding: '16px 0',
            }}
            onClick={() => {
              if (validateEmail(email) && phonecheck && authCheck) {
                setText('agree')
              }
            }}
          >
            입력완료
          </button>
        </div>
      </div>
    </>
  )
}
